// removed by extract-text-webpack-plugin
module.exports = {"button":"subject-controls__button___2VVDS","buttonsContainer":"subject-controls__buttonsContainer___3n_px"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/subjects/subject-controls.css
// module id = 1208
// module chunks = 0